import React from 'react';
import PropTypes from 'prop-types';
import {Select} from "antd";

const Option = Select.Option;

export default class ProductAutoComplete extends React.Component {
  static propTypes = {
    onSearch: PropTypes.func.isRequired,
    products: PropTypes.array.isRequired,
    //
    onChange: PropTypes.func,
    value: PropTypes.any,
  };

  handleProductSearch = value => {
    if (this.searchTimeout) clearTimeout(this.searchTimeout);
    this.searchTimeout = setTimeout(this.props.onSearch, 300, value);
  };

  render() {
    return (
      <Select
        showSearch
        value={this.props.value}
        placeholder="Search product"
        defaultActiveFirstOption={false}
        showArrow={false}
        filterOption={false}
        onSearch={this.handleProductSearch}
        onChange={this.props.onChange}
        notFoundContent={null}
      >
        {this.props.products.map(product =>
          <Option key={product.productId} value={product.productId}>{product.display}</Option>
        )}
      </Select>
    );
  }
}


// WEBPACK FOOTER //
// ./src/Product/ProductAutoComplete.js